import React, { useState, useEffect, createContext } from "react";
import { useHistory } from "react-router-dom";

const TicketsContext = createContext();

const TicketsContextProvider = ({ children }) => {
	const [currentTicket, setCurrentTicket] = useState({ id: null, code: null });
	const [tabOpen, setTabOpen] = useState("open");
	const [globalUnreadTotal, setGlobalUnreadTotal] = useState(0);
	const history = useHistory();

	useEffect(() => {
		if (currentTicket.id !== null) {
			// focusMessageId (setado quando o ticket veio de um resultado de
			// busca por mensagem, ver TicketListItemCustom.handleSelectTicket)
			// vai como state da rota, não como query param, pra não mudar a URL
			// visível nem sobreviver a um F5/compartilhamento do link.
			history.push({
				pathname: `/tickets/${currentTicket.uuid}`,
				state: currentTicket.focusMessageId
					? { focusMessageId: currentTicket.focusMessageId }
					: undefined
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentTicket])

	return (
		<TicketsContext.Provider
			value={{ currentTicket, setCurrentTicket, tabOpen, setTabOpen, globalUnreadTotal, setGlobalUnreadTotal }}
		>
			{children}
		</TicketsContext.Provider>
	);
};

export { TicketsContext, TicketsContextProvider };
